'use client';

import { useCmsClientContext } from '../../../../../utils/cmsPageContext';
import { getClientTranslations } from '../../../../../utils/translations/getClientTranslations';
import { useBreakpoint } from '../../../../../utils/useBreakpoint';
import { CmsImage } from '../../../../CmsImage';
import { EXCLUSIVE_REWARDS_TRANSLATIONS } from '../../i18n';
import { RewardsInfoProps } from '../../types';
import GiftsCarousel from '../GiftsCarousel';

const RewardsInfo: React.FC<RewardsInfoProps> = ({
  singleGiftOffers,
  multipleGiftsOffers,
  isGiftOffersAvailable,
}) => {
  const context = useCmsClientContext();
  const staticText = getClientTranslations(
    EXCLUSIVE_REWARDS_TRANSLATIONS,
    context,
  );
  const isMobile = useBreakpoint({ _: true, md: false });

  return (
    <div className="grow md:self-start self-stretch gap-4 h-auto py-4 md:py-6 overflow-hidden flex flex-col justify-start items-start rounded-2xl lg:rounded-3xl bg-white shadow-md">
      <div className="flex flex-col gap-4 self-stretch w-full">
        {!isGiftOffersAvailable && (
          <p className="alpha-title-2 text-text/primary px-4 md:px-6">
            {staticText.noRewards}
          </p>
        )}
        {!!multipleGiftsOffers.length && (
          <p className="alpha-title-2 text-text/primary px-4 md:px-6">
            {staticText.multipleRewards}
          </p>
        )}
        {multipleGiftsOffers.map((item) => (
          <GiftsCarousel key={item.uid} gifts={item.list_of_gifts ?? []} />
        ))}
        {isGiftOffersAvailable && (
          <p className="alpha-title-2 text-text/primary px-4 md:px-6">
            {multipleGiftsOffers.length
              ? staticText.multipleGiftsAvailable
              : staticText.multipleGiftsNotAvailable}
          </p>
        )}
        <div className="px-4 md:px-6 gap-2 lg:gap-4 flex flex-col">
          {singleGiftOffers.map((item) => {
            const gift = item.list_of_gifts?.[0]?.gift;
            if (!gift) return null;

            return (
              <div
                key={`rewards_gift__${gift.uid}`}
                className="p-2 md:p-4 rounded-lg bg-gray-100 items-center flex flex-row gap-2 md:gap-4"
              >
                <div className="flex shrink-0 items-center justify-center rounded-lg  bg-white p-2  outline outline-1 outline-gray-300 w-20 md:px-4 md:mr-0 lg:w-47 lg:max-w-47 md:w-35 md:max-w-35 md:h-14 sm:h-12">
                  <CmsImage
                    className="size-full object-contain"
                    sizes={{ _: 156 }}
                    src={
                      isMobile
                        ? gift.mobile_image || gift.desktop_image
                        : gift.desktop_image
                    }
                    alt="gift logo"
                    width={156}
                    height={40}
                  />
                </div>
                <p className="gap-2 alpha-badge text-primary-800">
                  {gift.gift_title}
                </p>
              </div>
            );
          })}
        </div>
        <span className="text-xs md:text-sm text-gray-700 font-medium px-4 md:px-6">
          {staticText.termsCampaign}{' '}
          <a
            href="https://www.singsaver.com.sg/page/singsaver-terms"
            target="_blank"
            rel="noreferrer"
            className="underline"
          >
            {staticText.termsApply}
          </a>
        </span>
      </div>
    </div>
  );
};

export default RewardsInfo;
